import { TOKEN_SCOPE } from '@kc-console/context';
import { STATUS_CODE } from '@kc-console/core';

import type { BaseState, Env, ServiceAppState } from '@kc-console/context';

export const INITIAL_DEFAULT_STATE: ServiceAppState = {
  status: STATUS_CODE.OK,
  redirect: null,
  env: (process.env.KC_ENV as Env) || 'stage',
  bffEndpoint: process.env.KC_BFF_ENDPOINT || '',
  iamEndpoint: process.env.KC_IAM_ENDPOINT || '',
  iamSSREndpoint: process.env.KC_IAM_SSR_ENDPOINT || '',
  token: '',
  domainId: '',
  domainName: '',
  projectId: '',
  projectName: '',
  serviceKeyword: '',
  region: undefined,
  language: '',
  displayLanguage: '',
  scope: TOKEN_SCOPE.PROJECT,
  userId: '',
  userName: '',
  defaultProjectId: '',
  accessibleProjects: [],
  error: null,
  isRegionForced: false,
  isProjectForced: false,
  ssrConfig: null,
};

export const ROUTE_DEFAULT_STATE: BaseState = {
  status: STATUS_CODE.OK,
  redirect: null,
  env: (process.env.KC_ENV as Env) || 'stage',
  ssrConfig: null,
  bffEndpoint: process.env.KC_BFF_ENDPOINT || '',
  iamEndpoint: process.env.KC_IAM_ENDPOINT || '',
  iamSSREndpoint: process.env.KC_IAM_SSR_ENDPOINT || '',
  error: null,
  language: '',
  displayLanguage: '',
  serviceKeyword: '',
};
